import React from 'react';
import PropTypes from 'prop-types';

const Headshot = ({ user, className }) => {
  const users = [].concat(user).slice(0, 2).reverse();
  const klassList = ['head-shot'];
  if (users.length > 1) { klassList.push('double'); }
  if (className) { klassList.push(className); }

  return (
    <div className={klassList.join(' ')}>
      {users.map(user => {
        return (
          <div key={user.id} className="head-shot-clip">
            <img src={user.headShotImage} alt={user.displayName} />
          </div>
        );
      })}
    </div>
  );
};

Headshot.propTypes = {
  user: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired
};

export default Headshot;
